import React from "react";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Pending() {
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut(auth);
    navigate("/login");
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Outfit:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Outfit', sans-serif; }
        .pending-wrap { display: flex; min-height: 100vh; }
        .pending-left { width: 38%; background: #060D1A; display: flex; flex-direction: column; justify-content: space-between; padding: 56px 48px; position: relative; overflow: hidden; }
        .pending-right { flex: 1; background: #ffffff; display: flex; flex-direction: column; justify-content: space-between; padding: 56px 56px; }
        .rings { position: absolute; bottom: -120px; right: -120px; width: 520px; height: 520px; pointer-events: none; }
        .ring { position: absolute; border-radius: 50%; transform: translate(-50%, -50%); top: 50%; left: 50%; }
        .pending-tag { display: inline-block; background: rgba(56,189,248,0.1); border: 1px solid rgba(56,189,248,0.25); color: #38BDF8; font-family: 'Outfit', sans-serif; font-size: 10px; font-weight: 600; padding: 4px 12px; border-radius: 999px; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 20px; }
        .status-badge { display: inline-flex; align-items: center; gap: 8px; background: #fef9ec; border: 1.5px solid #C9A84C; border-radius: 999px; padding: 8px 20px; margin-bottom: 28px; }
        .logout-btn { width: 100%; padding: 15px; border-radius: 12px; background: transparent; border: 2px solid #e8e8e8; color: #999; font-family: 'Outfit', sans-serif; font-size: 15px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; cursor: pointer; }
        .logout-btn:hover { border-color: #0038A8; color: #0038A8; }
        .mobile-top { display: none; background: #060D1A; padding: 32px 24px 28px; }
        @media (max-width: 768px) {
          .pending-wrap { flex-direction: column; }
          .pending-left { display: none; }
          .mobile-top { display: block; }
          .pending-right { padding: 32px 24px 40px; }
        }
      `}</style>

      <div className="pending-wrap">

        <div className="mobile-top">
          <div className="pending-tag">Inside Out Leadership</div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#fff", letterSpacing: -1, lineHeight: 1.1 }}>LEAD</span>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#0038A8", letterSpacing: -1, lineHeight: 1.1 }}>NOW</span>
          </div>
          <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#C9A84C", margin: 0, lineHeight: 1.6, fontWeight: 600 }}>
            A leadership development program of LGU of Pasig and Victory Pasig
          </p>
        </div>

        <div className="pending-left">
          <div className="rings">
            <div className="ring" style={{ width: 100, height: 100, border: "1px solid rgba(201,168,76,0.2)" }} />
            <div className="ring" style={{ width: 210, height: 210, border: "1px solid rgba(201,168,76,0.15)" }} />
            <div className="ring" style={{ width: 340, height: 340, border: "1px solid rgba(255,255,255,0.12)" }} />
            <div className="ring" style={{ width: 500, height: 500, border: "1px solid rgba(255,255,255,0.07)" }} />
            <div className="ring" style={{ width: 8, height: 8, background: "rgba(201,168,76,0.4)", border: "none" }} />
          </div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="pending-tag">Inside Out Leadership</div>
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 56, fontWeight: 600, color: "#ffffff", letterSpacing: -1, lineHeight: 1.1 }}>LEAD</span>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 56, fontWeight: 600, color: "#0038A8", letterSpacing: -1, lineHeight: 1.1 }}>NOW</span>
            </div>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#C9A84C", margin: 0, lineHeight: 1.7, fontWeight: 600 }}>
              A leadership development program of<br />LGU of Pasig and Victory Pasig
            </p>
          </div>

          <div style={{ position: "relative", zIndex: 1, height: 20 }} />
        </div>

        <div className="pending-right">
          <div style={{ width: "100%", maxWidth: 440, margin: "auto" }}>

            <div className="status-badge">
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#C9A84C" }} />
              <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 700, color: "#C9A84C", letterSpacing: 1, textTransform: "uppercase" }}>Pending Approval</span>
            </div>

            <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: 28, fontWeight: 700, color: "#060D1A", marginBottom: 12, letterSpacing: -0.3 }}>
              You're almost in.
            </h2>

            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, color: "#555", lineHeight: 1.8, marginBottom: 16 }}>
              Your registration has been received. The LEADNOW program team is reviewing your application.
            </p>

            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: "#999", lineHeight: 1.8, marginBottom: 40 }}>
              You will be notified once your account has been approved. This usually takes 1 to 2 business days. Once approved you can sign in and begin your leadership journey.
            </p>

            <div style={{ background: "#f5f6fa", borderRadius: 14, padding: "20px 24px", marginBottom: 32, borderLeft: "4px solid #0038A8" }}>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: "#666", margin: 0, lineHeight: 1.7 }}>
                While you wait — think about this: <br />
                <span style={{ color: "#060D1A", fontWeight: 600 }}>What kind of leader do you want to become?</span>
              </p>
            </div>

            <button onClick={handleLogout} className="logout-btn">
              Back to Login
            </button>
          </div>

          <p style={{ fontFamily: "'Outfit', sans-serif", textAlign: "center", fontSize: 9, color: "rgba(0,0,0,0.15)", letterSpacing: 1, textTransform: "uppercase" }}>
            © 2026 GOSECOND INC. All rights reserved.
          </p>
        </div>

      </div>
    </>
  );
}